import { render, staticRenderFns } from "./TimeTraveller.vue?vue&type=template&id=50720ebf&scoped=true&"
import script from "./TimeTraveller.vue?vue&type=script&lang=js&"
export * from "./TimeTraveller.vue?vue&type=script&lang=js&"
import style0 from "./TimeTraveller.vue?vue&type=style&index=0&id=50720ebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50720ebf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50720ebf')) {
      api.createRecord('50720ebf', component.options)
    } else {
      api.reload('50720ebf', component.options)
    }
    module.hot.accept("./TimeTraveller.vue?vue&type=template&id=50720ebf&scoped=true&", function () {
      api.rerender('50720ebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/TimeTraveller.vue"
export default component.exports